import { isPanoramicTheme } from '@pano-project/variables/is-panoramic-2-0-theme';
import { locationCashierTheme } from 'utils/helper-functions/get-url-vars';
export const isTwoFieldsAmount = locationCashierTheme === 'power-slide' || isPanoramicTheme;
